import React from 'react'

import Button from 'content-components/_Primatives/Button'

type Props = {
  className?: string
  children: React.ReactNode
  url: string
}

function VerifyEmailButton({ className, url, children }: Props) {
  return (
    <Button className={className} url={url} variant='primaryBlue'>
      {children}
    </Button>
  )
}

export default VerifyEmailButton
